export default __webpack_public_path__ + "static/1784-1e10d854d5427f1bbcbab74c6883108e.gif";